<ng-template #groupHolder let-nestedCheckGroups="nestedCheckGroups">
  <div class="group-holder" *ngFor="let checkboxGroup of data.nestedCheckGroups; let first = first">
    <div class="instructions" *ngIf="!!checkboxGroup.instructions" [ngClass]="{ notFirst: !first }">
      <div class="title" *ngIf="!!checkboxGroup.instructions.title">{{ checkboxGroup.instructions.title }}</div>
      <div class="text" *ngIf="!!checkboxGroup.instructions.text">{{ checkboxGroup.instructions.text }}</div>
    </div>
    <title-toggle-wrapper 
      *ngIf="checkboxGroup.tabId" 
      [class]="checkboxGroup.tabId"
      [title]="checkboxGroup.groupName"
      [toggleOn]="!deselectedIds.has(checkboxGroup.tabId)"
      [hideBottom]="deselectedIds.has(checkboxGroup.tabId)"
      (toggle)="toggleTab(checkboxGroup.tabId)"
    >
      <ng-container> 
        <div class="topHint grey-hint" *ngIf="!!checkboxGroup.topHint">{{ checkboxGroup.topHint }}</div>
        <mutating-input *ngIf="!checkboxGroup.noTabName" [object]="tabNames" [hint]="checkboxGroup.hintText" [prop]="checkboxGroup.tabId" [focus]="false" [placeholder]="'Tab name'"></mutating-input>
        <ng-container *ngIf="!!checkboxGroup.radios">
          <mat-radio-group *ngFor="let radioGroup of checkboxGroup.radios" (ngModelChange)="onRadioChange($event, radioGroup)"
            name="detail" class="detail-select" [(ngModel)]="data.radioChoices[radioGroup.id]" required>
            <ng-container *ngFor="let radio of radioGroup.choices">
              <mat-radio-button [value]="radio.id">
                {{ radio.label }}
              </mat-radio-button>
            </ng-container>
          </mat-radio-group>
        </ng-container>
        <ng-container *ngIf="checkboxGroup.children">
          <ng-container *ngFor="let child of checkboxGroup.children"
            [ngTemplateOutlet]="checkboxWrapper" 
            [ngTemplateOutletContext]="{ checkboxGroup: child }"
          ></ng-container>
        </ng-container> 
      </ng-container>  
    </title-toggle-wrapper>
    <ng-container 
      *ngIf="!checkboxGroup.tabId && !checkboxGroup.instructions && (!checkboxGroup.hideId || !deselectedIds.has(checkboxGroup.hideId))"
      [ngTemplateOutlet]="checkboxWrapper" 
      [ngTemplateOutletContext]="{ checkboxGroup: checkboxGroup }"
    ></ng-container>
  </div>
  
</ng-template>

<ng-template #checkboxWrapper let-checkboxGroup="checkboxGroup">
  <expanding-wrapper [title]="checkboxGroup.groupName" [borderGreyOnCollapse]="true" (onDone)="checkInitialized()">
    <div class="multi-select">
      <div style="flex:1;"></div>
      <div class="action" (click)="selectGroup(checkboxGroup)">Select All</div>
      <div class="action" (click)="unselectGroup(checkboxGroup)">Unselect All</div>
    </div>
    
    <ng-container *ngFor="let nestedCheck of checkboxGroup.checkboxes;" [ngTemplateOutlet]="nestedCheckbox" [ngTemplateOutletContext]="{ nestedCheck: nestedCheck }"></ng-container>
    <title-toggle-wrapper 
      *ngIf="checkboxGroup.endingTabDropdown as dropdown" 
      class="ending-tab"
      [title]="dropdown.title"
      [toggleOn]="!deselectedIds.has(dropdown.id)"
      [hideBottom]="deselectedIds.has(dropdown.id)"
      (toggle)="toggleTab(dropdown.id)"
    >
      <dropdown [selections]="dropdown.dropdownOptions" [selected]="dropdown.currentSelection" (select)="updateValue('venue', $event.id)"></dropdown>
    </title-toggle-wrapper>
    
  </expanding-wrapper>
</ng-template>
<ng-template #nestedCheckbox let-nestedCheck="nestedCheck">
  <div class="holder">
    <div class="label-holder" [ngClass]="{ disabled: nestedCheck.disabled }">
      <mat-checkbox color="primary" (change)="toggleNested(nestedCheck)" [checked]="!deselectedIds.has(nestedCheck.id)"></mat-checkbox>
      <div class="label">{{ nestedCheck.label }}</div>
    </div>
    <div *ngIf="nestedCheck.children" class="children-wrapper">
      <ng-container *ngFor="let nestedChild of nestedCheck.children;" [ngTemplateOutlet]="nestedCheckbox" [ngTemplateOutletContext]="{ nestedCheck: nestedChild }"></ng-container>
    </div>
  </div>
</ng-template>

<dialog-wrapper
  [ngClass]="{ hidden: !initialized }"
  [backgroundColor]="data.backgroundColor"
  [successLabel]="data.successLabel"
  [dontResize]="true"
  [disabled]="false"
  [dialogTitle]="data.title"
  [cancelRight]="true"
  (cancel)="cancel()"
  (submit)="submit()"
>
  <!--
  <div class="multi-select">
    <div style="flex:1;"></div>
    <div class="action" (click)="selectAll()">Select All</div>
    <div class="action" (click)="unselectAll()">Unselect All</div>
  </div>-->
  <div class="instructions" *ngIf="data.instructions">{{ data.instructions }}</div>
  <div class="views" *ngIf="data.views">
    <div class="view-title">Preselected Views:</div>
    <div class="view" *ngFor="let view of data.views" [ngClass]="{ active: view.ids | setsEqual:deselectedIds }" (click)="useView(view)">
      {{ view.title }}
    </div>
  </div>
  <ng-container [ngTemplateOutlet]="groupHolder" [ngTemplateOutletContext]="{ nestedCheckGroups: data.nestedCheckGroups }"></ng-container>
  
</dialog-wrapper>